<template>
  <Row>
    <Column :width="15" :key="redraw">
      <div id="detailsModal" class="rc-modal-dialog">
        <!-- Modal content -->
        <div class="rc-modal-content-dialog-wide">
          <div class="rc-modal-header-dialog">
            <Box >
              <Row 
                v-for="(row, rowIndex) in viewHeaderData" 
                :key="rowIndex" >
                  <CellFactory 
                    :rowData="row.data"
                    :showMissingRequirements="showMissingRequirements"
                    v-on:withValue="withFieldValue"
                    v-on:withButtonPressed="withButtonPressed"
                    />
              </Row>
            </Box>
          </div>

          <div class="rc-modal-body-dialog">
            <div class="rc-modal-body-inner-dialog rc-border-thin">
              <Box>
                <Row 
                  v-for="(row, rowIndex) in viewBodyData" 
                  :key="rowIndex" >
                    <CellFactory 
                      :rowData="row.data"
                      :showMissingRequirements="showMissingRequirements"
                      v-on:withValue="withFieldValue"
                      v-on:withButtonPressed="withButtonPressed"
                      />
                </Row>
              </Box>
            </div>
          </div>

          <div class="rc-modal-footer-dialog">
            <Box>
              <Row 
                v-for="(row, rowIndex) in viewFooterData" 
                :key="rowIndex" >
                  <CellFactory 
                    :rowData="row.data"
                    :showMissingRequirements="showMissingRequirements"
                    v-on:withValue="withFieldValue"
                    v-on:withButtonPressed="withButtonPressed"
                    />
              </Row>
            </Box>
          </div>
        </div>
      </div>
    </Column>
  </Row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import ConnectionUtils from '@/utils/ConnectionUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import MC from "@/domain/session/MC.js";

import CellFactory from "@/portals/shared/cell/CellFactory.vue";
import Box from "@/portals/shared/library/box/Box.vue";
import Column from "@/portals/shared/library/box/Column.vue";
import Row from "@/portals/shared/library/box/Row.vue";

import LabelValueDisplayRow from "@/portals/shared/cell/label/LabelValueDisplayRow";
import ValueDisplayRow from "@/portals/shared/cell/value/ValueDisplayRow";
import BoxDisplayRow from "@/portals/shared/cell/box/BoxDisplayRow";
import ButtonDisplayRow from "@/portals/shared/cell/button/ButtonDisplayRow";
import ErrorDisplayRow from "@/portals/shared/cell/error/ErrorDisplayRow";
import RowDisplayRow from "@/portals/shared/cell/row/RowDisplayRow";
import SpacerDisplayRow from '@/portals/shared/cell/spacer/SpacerDisplayRow';
import StringDisplayRow from "@/portals/shared/cell/string/StringDisplayRow";
// import StringUpdateRow from "@/portals/shared/cell/string/StringUpdateRow";
import TitleDisplayRow from "@/portals/shared/cell/title/TitleDisplayRow";
// import TextAreaUpdateRow from '@/portals/shared/cell/textarea/TextAreaUpdateRow';
// import DateUpdateRow from "@/portals/shared/cell/date/DateUpdateRow";

// import UsersRow from './users/UsersRow.vue';
// import VehiclesRow from './vehicles/VehiclesRow.vue';

// import Report from '@/domain/model/report/Report.js';
// import ReportMap from '@/domain/model/report/ReportMap.js';
// import ReportParams from '@/domain/model/report/ReportParams.js';

// import UserMap from "@/domain/model/user/UserMap.js";
// import VehicleMap from "@/domain/model/vehicle/VehicleMap.js";

export default {
  name: "report-list-details-view",
  components: {
    Column, Row, 
    Box,
    CellFactory,
  },
  props: {
    itemId: { type: String, default: "" },
  },
  data() {
    return {
      redraw: 1,
      
      MC: new MC(),
      Strings: StringUtils,
      Contents: ContentUtils,
      Consts: ConstUtils,

      showMissingRequirements: false,
      viewHeaderData: [],
      viewBodyData: [],
      viewFooterData: [],

      kvps: {},
      error: null,
    };
  },
  computed: {
    ...mapGetters([
                   'auth_connected',
                   'auth_socket_status',
                   'signin_event',
                   'auth_client',
                   'domain',
                   ]),
  },
  watch: {
    auth_connected() {
      ConnectionUtils.sendSignInEvent(this);
    },
    auth_socket_status() {
      ConnectionUtils.displayStatus(this);
    },
    signin_event() {
      ConnectionUtils.createDomainSession(this);
    }
  },
  mounted: function () {
    ConnectionUtils.ensureConnection(this);
  },
  methods: {
    ...mapActions([
                   'addListenerAction',
                   'removeListenerAction',
                   'updateDomain',
                   ]),

    start: function() {
      this.setup();
      this.mainScreen();
    },

    setup: function() {
      // window.onclick = this.onClick;
    },

    mainScreen() {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];

      var id = ContentUtils.baseDecode(this.itemId);
      var report = this.domain.reports().findById(id);
      
      var users = report.users().find();
      let userList = users.sortByName();
      
      var vehicles = report.vehicles().find();
      let vehicleList = vehicles.sortByName();

      this.viewHeaderData.push(new TitleDisplayRow().withTitle(StringUtils.format("Details for Report: {0}", [report.name()])));

      var errorBox = new BoxDisplayRow().withBorder(true)
                          .withChild(new RowDisplayRow()
                            .withChild(new SpacerDisplayRow().withWidth("1"))
                            .withChild(new ErrorDisplayRow().withWidth("13").withError(this.error))
                            .withChild(new SpacerDisplayRow().withWidth("1"))
                          );
      if (this.error) {
        this.viewBodyData.push(errorBox);
      }

      let usersRow = new BoxDisplayRow();
      for (let index = 0; index < userList.length; index++) {
        let user = userList[index];
        let userRow = new RowDisplayRow();
          userRow
            .withChild(new ValueDisplayRow().withWidth(15).withValue((index + 1) + " " + user.fullName()))
        usersRow.addChild(userRow);
      }
      usersRow.addChild(new SpacerDisplayRow());

      let vehiclesRow = new BoxDisplayRow();
      for (let index = 0; index < vehicleList.length; index++) {
        let vehicle = vehicleList[index];
        let vehicleRow = new RowDisplayRow();
          vehicleRow
            .withChild(new ValueDisplayRow().withWidth(15).withValue((index + 1) + " " + vehicle.name() + " " + vehicle.plate()))
        vehiclesRow.addChild(vehicleRow);
      }
      vehiclesRow.addChild(new SpacerDisplayRow());

      let linkRows = new BoxDisplayRow();
      let links = report.links();
      if (links) {
        for (let index = 0; index < links.length; index++) {
          let link = links[index];
          linkRows.addChild(new RowDisplayRow()
                                  .withChild(new LabelValueDisplayRow().withLabelWidth(2).withLabel("Name").withValue(link.substring(link.lastIndexOf("/") + 1, link.length)).withWidth(10))
                                  .withChild(new SpacerDisplayRow().withWidth(3))
                                  .withChild(new ButtonDisplayRow().withName("Download").withWidth(2).withField("Download").withObject(link).withId(report.id()))
              );
        }
      } else {
        linkRows.addChild(new StringDisplayRow().withValue("No links created"));
      }
      let bodyRow = new BoxDisplayRow()
                          .withWidth("11")
                          .withChild(new LabelValueDisplayRow().withLabelWidth(2).withLabel("Template Name").withValue("Inspection and Hours of Service export to zip file").withKey("name").withField("field").withObject("Report"))
                          .withChild(new LabelValueDisplayRow().withLabelWidth(2).withLabel("Name").withValue(report.name()).withKey("field").withField("name").withObject("Report").withMandatoryValue(true))
                          .withChild(new LabelValueDisplayRow().withLabelWidth(2).withLabel("Description").withValue(report.description()).withKey("field").withField("description").withObject("Report"))
                          .withChild(new SpacerDisplayRow())
                          .withChild(new BoxDisplayRow().withBorder()
                            .withChild(new TitleDisplayRow().withTitle("Parameters").withSubtitle(true))
                            .withChild(new RowDisplayRow()
                              .withChild(new LabelValueDisplayRow().withWidth(5).withLabel("Start Time").withMandatoryValue(true).withField("startTime").withValue(report.startTimeV2().displayAs_YYYY_MM_DD()))
                              .withChild(new LabelValueDisplayRow().withWidth(5).withLabel("End Time").withMandatoryValue(true).withField("endTime").withValue(report.endTimeV2().displayAs_YYYY_MM_DD()))
                            )
                            .withChild(new BoxDisplayRow().withBorder()
                              .withChild(new TitleDisplayRow().withTitle("Users").withSubtitle(true))
                              .withChild(usersRow)
                            )
                            .withChild(new BoxDisplayRow().withBorder()
                              .withChild(new TitleDisplayRow().withTitle("Vehicles").withSubtitle(true))
                              .withChild(vehiclesRow)
                            )
                          )
                          .withChild(new BoxDisplayRow().withBorder()
                            .withChild(new TitleDisplayRow().withTitle("Results").withSubtitle(true))
                            .withChild(linkRows)
                          )

      this.viewBodyData.push(bodyRow);

      let footerRow = new BoxDisplayRow()
                  .withBorder(true)
                  .withChild(
                    new RowDisplayRow()
                      .withChild(new ButtonDisplayRow().withWidth(2).withName("Cancel").withField("DetailsClose"))
                      .withChild(new StringDisplayRow().withWidth(13))
                  );
      this.viewFooterData.push(footerRow);
    },

    sendingScreen() {
      this.viewBodyData = [];
      this.viewFooterData = [];
      this.viewHeaderData = [];

      let bodyBox = new BoxDisplayRow().withChild(new RowDisplayRow()
                              .withChild(new SpacerDisplayRow().withWidth("2"))
                              .withChild(new BoxDisplayRow()
                                    .withWidth("11")
                                    .withChild(new StringDisplayRow()
                                                  .withMandatoryValue(true)
                                                  .withValue("Sending"))
                                  )
                              .withChild(new SpacerDisplayRow().withWidth("2"))
                            );
      this.viewBodyData.push(bodyBox);
      this.paint();
    },

    doneScreen() {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];

      let bodyBox = new BoxDisplayRow().withChild(new RowDisplayRow()
                              .withChild(new SpacerDisplayRow().withWidth("2"))
                              .withChild(new BoxDisplayRow()
                                    .withWidth("11")
                                    .withChild(new StringDisplayRow()
                                                  .withMandatoryValue(true)
                                                  .withValue("Done!"))
                                  )
                              .withChild(new SpacerDisplayRow().withWidth("2"))
                            );

      this.viewBodyData.push(bodyBox);
      this.paint();
    },

    paint: function() {
      this.redraw++;
    },

    log() {
      return this.domain.logger();
    },

    onClick: function(event) {
      var modal = document.getElementById("detailsModal");
      if (event.target == modal) {
        this.goBack();
      }
    },
    
    withButtonPressed: function(buttonData) {
      this.showMissingRequirements = false;
      this.log().info("Dialog Button {0}", [JSON.stringify(buttonData, null, 2)]);

      if (buttonData["field"] === "DetailsClose") {
        this.$emit("withButtonPressed", buttonData);

      } else if (buttonData["field"] === "Send") {
        this.doSendAction();

      } else if (buttonData["field"] === "Download") {
        let host = this.domain.client().cdnHost;
        var url = ContentUtils.escape(buttonData["object"]);
        url = url.replace("#", "%23");
        url = host + "/companys/" + url;
        this.log().info("Download link {0}", [url]);
        window.open(url, '_blank');
      }
    },

    doSendAction() {
      setTimeout(2000, this.doneSendAction);
    },

    doneSendAction(notification) {
      if (!notification) {
        return;
      }
    },

    withFieldValue: function(valueData) {
      if (valueData) {
        //
      }
      this.showMissingRequirements = false;
    },

    displayProgress: function(msg) {
      this.callback(msg);
    },

    callback: function(msg) {
      if (msg) {
        //
      }
    },

    areRequirementsMet: function() {
      var met = true;
      return met;
    },

    goBack: function() {
      this.$router.back();
    }
  },
}
</script>